<div class="station-card">
  <div class="station">
    <input [value]="stationId + '  ' + stationName" disabled>
  </div>
  <div class="icon">
    <mat-icon (click)="deleteStation()">remove_circle</mat-icon>
  </div>
</div>
